'use client';

import { PropsWithChildren, useState } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { UserProvider } from 'components/providers/UserProvider';
import { Notifications } from 'components/shared/Notifications';
import { ProgressDialog } from 'components/shared/ProgressDialog';
import { Hotjar } from 'components/shared/layout/Hotjar';

/**
 * The only provider tree — the Pages Router (and its `pages/_app.tsx`) is
 * gone, so QueryClient, UserProvider, Notifications, ProgressDialog and
 * Hotjar are mounted once, here, for the whole app.
 */
export function Providers({ children }: PropsWithChildren) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        {children}
        <ProgressDialog />
      </UserProvider>

      <Notifications />
      <Hotjar />
    </QueryClientProvider>
  );
}
